import React, { useEffect } from 'react';
import { useApp } from '../../context/AppContext.tsx';

export default function PortfolioDetailModal() {
  const { selectedPortfolio, setSelectedPortfolio, navigate } = useApp();

  useEffect(() => {
    if (selectedPortfolio) {
      navigate('portfolio-detail', selectedPortfolio.slug || selectedPortfolio.id);
      setSelectedPortfolio(null);
    }
  }, [selectedPortfolio, navigate, setSelectedPortfolio]);

  return null;
}
